/**
 * Осуществляет автоматическую отправку данных при вводе текста в поле с
 * указанной задержкой (т.е. если вводим что-то в поле и остановились, то
 * сработает change()   )
 */
jQuery.fn.extend({
	autoChangeOnInput:function(params){
        var items = $(this);
        var params = params || {};
        var delay = params.delay || 1000;

        items.each(function(i, el){
            var timer;
            var value;

            $(el).keyup(function(e){

                clearTimeout(timer);
                if(e.keyCode == 13){
                    $(el).trigger('change');
                } else {
                    timer = setTimeout(function(){
                        if(value != $(el).val()){
                            $(el).trigger('change');
                        }
                    }, delay);
                }

            });

            $(el).focus(function(e){
                value = $(this).val();
            })

            $(el).change(function(e){
                value = $(this).val();
            });
        })

    }
});
